import { DropdownItem } from "@mcleod/components";
import { StringUtil } from "@mcleod/core";
import { DuplicateId } from "../DuplicateId";
import { AutogenLayoutMobileCommLandmarkTools } from "./autogen/AutogenLayoutMobileCommLandmarkTools";

//const dropdownNoMap = new DropdownItem("N", "--");
const dropdownTrimbleMap = new DropdownItem("W", "Trimble");
const dropdownGoogleMap = new DropdownItem("G", "Google");

export class MobileCommLandmarkTools extends AutogenLayoutMobileCommLandmarkTools {
    override onLoad(): void {
        this.textboxFindnearVendor.items = [dropdownTrimbleMap, dropdownGoogleMap];
    }

    public setFindnearVendorItem(item: string) {
        if (item == "G") {
            this.textboxFindnearVendor.selectedItem = dropdownGoogleMap;
        } else if (item == "W") {
            this.textboxFindnearVendor.selectedItem = dropdownTrimbleMap;
        }
    }

    public setComponentsVisibility(inAddMode: boolean) {
        if (inAddMode) {
            this.buttonAddLandmark.visible = false;
            this.textboxName.text = "";
            this.textboxName.visible = true;
            this.textboxDescr.text = "";
            this.textboxDescr.visible = true;
            this.buttonCancelLandmark.visible = true;
            this.buttonSaveLandmark.visible = true;
            this.textboxLatitude.visible = true;
            this.textboxLongitude.visible = true;
            this.textboxName.focus();
        } else {
            this.buttonAddLandmark.visible = true;
            this.textboxName.visible = false;
            this.textboxDescr.visible = false;
            this.textboxLatitude.visible = false;
            this.textboxLongitude.visible = false;
            this.buttonCancelLandmark.visible = false;
            this.buttonSaveLandmark.visible = false;
        }
    }

    public validateId(): Promise<boolean> {
        return new Promise(async (resolve) => {
            this.textboxName.validationWarning = null;

            if (StringUtil.isEmptyString(this.textboxName.text)) {
                this.textboxName.validationWarning = "Name is a required field";
                resolve(false);
            } else {
                DuplicateId.checkManualCode("mc_landmark", this.textboxName.text)
                    .then((response) => {
                        if (response.data?.[0]?.is_duplicate) {
                            this.textboxName.validationWarning = "Name is a duplicate of an existing code";
                            resolve(false);
                        } else {
                            resolve(true);
                        }
                    });
            }
        });
    }
}



